import {getUserInfo, loginByUsername, logout} from '@/api/login'
import {getClientRechargePhone, setClientRechargePhone, getAgentBalanceTransferPhone, setAgentBalanceTransferPhone, getToken, getUser, removeToken, removePwdChangeAt, removeUser, setToken, setPwdChangeAt, setUser} from '@/utils/auth'

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    client_recharge_phone: getClientRechargePhone(),
    agent_balance_transfer_phone: getAgentBalanceTransferPhone(),
    name: getUser(),
    avatar: '',
    introduction: '',
    roles: [],
    permissions: [],
    isArch: false,
    info: false,
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PWD_CHANGE_AT: (state, time) => {
      state.pwd_change_at = time
    },
    SET_CLIENT_RECHARGE_PHONE: (state, phone) => {
      state.client_recharge_phone = phone
    },
    SET_AGENT_BALANCE_TRANSFER_PHONE: (state, phone) => {
      state.agent_balance_transfer_phone = phone
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.info = true
      state.permissions = permissions
    },
    SET_ARCH: (state, isArch) => {
      state.isArch = parseInt(isArch)
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password, userInfo.captcha).then(response => {
          const data = response.data
          commit('SET_PWD_CHANGE_AT', data.pwd_change_at)
          commit('SET_TOKEN', data.token)
          commit('SET_NAME', username)
          commit('SET_CLIENT_RECHARGE_PHONE', data.client_recharge_phone)
          commit('SET_AGENT_BALANCE_TRANSFER_PHONE', data.agent_balance_transfer_phone)
          setToken(response.data.token)
          setPwdChangeAt(response.data.pwd_change_at)
          setClientRechargePhone(response.data.client_recharge_phone)
          setAgentBalanceTransferPhone(response.data.agent_balance_transfer_phone)
          setUser(username)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          // 由于mockjs 不支持自定义状态码只能这样hack
          if (!response.data) {
            reject(function () {}())
          }
          const data = response.data
          commit('SET_PERMISSIONS', data.permissions)
          commit('SET_ARCH', data.is_arch)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ARCH', false)
          commit('SET_PERMISSIONS', [])
          commit('SET_CLIENT_RECHARGE_PHONE', '')
          commit('SET_AGENT_BALANCE_TRANSFER_PHONE', '')
          removeToken()
          removePwdChangeAt()
          removeUser()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removePwdChangeAt()
        removeUser()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles ({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_PERMISSIONS', data.permissions)
          commit('SET_ARCH', data.is_arch)
          const permissions = data.permissions // note: roles must be a array! such as: ['editor','develop']
          const isArch = data.is_arch
          dispatch('GenerateRoutes', { permissions, isArch }) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js